import React, { useContext } from 'react';
import { LanguageContext } from '../../../context/LanguageContext/LanguageContext';
import { mainBannerResidenciales, mainBannerResidencialesEn } from '../../../json/services/residenciales/mainBannerResidenciales';
import MainBanner from '../../Nosotros/MainBanner/MainBanner';
import KnowService from '../KnowService/KnowService';
import { knowServiceResidencial, knowServiceResidencialEn } from '../../../json/services/residenciales/knowServiceResidencial';
import ServiceList from '../ServiceList/ServiceList';
import { serviceListResidenciales, serviceListResidencialesEn } from '../../../json/services/residenciales/serviceListResidenciales';
import ServiceBanner from '../ServicesBanner/ServicesBanner';
import { ServicesBannerResidenciales, ServicesBannerResidencialesEn } from '../../../json/services/residenciales/servicesBannerResidenciales';

const Residenciales = () => {
  const { language } = useContext(LanguageContext);
  const data = language === 'ES'
    ? mainBannerResidenciales[0]
    : mainBannerResidencialesEn[0];

  const content = language === 'ES' ? knowServiceResidencial[0] : knowServiceResidencialEn[0];

  const services = language === "ES" ? serviceListResidenciales : serviceListResidencialesEn;

  const dataServiceBanner = language === 'ES'
  ? ServicesBannerResidenciales[0]
  : ServicesBannerResidencialesEn[0];

  return (
    <>
      <MainBanner {...data} />
      <KnowService content={content} />
      <ServiceList services={services} />
      <ServiceBanner dataServiceBanner={dataServiceBanner} />
    </>
  )
}

export default Residenciales